import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

interface StepState {
  path: string;
  isActive: boolean;
  isCompleted: boolean;
}

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent implements OnInit, OnDestroy {
  @Input() is_processing: boolean = false;
  steps = [
    {
      label: 'buses.bulk-enroll.stepper.upload',
      path: '/buses/bulk-enroll/upload-file',
      svg: 'upload',
      processing_label: 'buses.bulk-enroll.stepper.upload'
    },
    // {
    //   label: 'buses.bulk-enroll.stepper.column',
    //   path: '/buses/bulk-enroll/column-mapping',
    //   svg: 'column'
    // },
    {
      label: 'buses.bulk-enroll.stepper.fix',
      path: '/buses/bulk-enroll/fix-errors',
      svg: 'fix',
      processing_label: 'buses.bulk-enroll.stepper.processing'
    },
    {
      label: 'buses.bulk-enroll.stepper.assign',
      path: '/buses/bulk-enroll/assign-trips',
      svg: 'assign',
      processing_label: 'buses.bulk-enroll.stepper.assign'
    }
  ];

  stepStates: StepState[] = [];
  private _currentUrl: string = '';
  private routerSubscription!: Subscription;

  constructor(
    public router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this._currentUrl = this.router.url;
    this.updateStepStates();
    this.subscribeToRouterEvents();
  }

  private subscribeToRouterEvents(): void {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this._currentUrl = event.urlAfterRedirects || event.url;
        this.updateStepStates();
        this.cdr.detectChanges();
      });
  }

  private updateStepStates(): void {
    const currentIndex = this.steps.findIndex(step => step.path === this._currentUrl);
    
    this.stepStates = this.steps.map((step, index) => ({
      path: step.path,
      isActive: step.path === this._currentUrl,
      isCompleted: index < currentIndex
    }));
  }

  // Getter to cache the current URL
  get currentUrl(): string {
    return this._currentUrl;
  }

  // Optimized method using pre-computed states
  isActive(path: string): boolean {
    const stepState = this.stepStates.find(state => state.path === path);
    return stepState ? stepState.isActive : false;
  }

  // Optimized method using pre-computed states
  isCompleted(path: string): boolean {
    const stepState = this.stepStates.find(state => state.path === path);
    return stepState ? stepState.isCompleted : false;
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
